import GridAnimation from "./Growth/GridAnimation";
import VideoPlayer from "./Growth/VideoPlayer";
import HeroAnimation from "./Growth/HeroAnimation";
import Sizes from "./Growth/Sizes";
import Latest from "./Growth/Latest";
import GrowthSmoothScroll from "./Growth/GrowthSmoothScroll";
import AnimationMobile from "./Growth/AnimationMobile";

export default class Growth {
    constructor() {
        this.body = document.querySelector('body');
        this.main = document.getElementById('main');
        this.sizes = Sizes.getInstance();

        this.body.classList.remove('locked');
        this.sizesCell = {};
        this.initCellsLayout();
        if(!this.sizes.getIsBreakpointTablet()) {
            const gridAnimationEls = document.querySelectorAll('.grid-animation-container');
            this.gridAnimations = [];
            if(gridAnimationEls.length) {
                gridAnimationEls.forEach(gridAnimationEl => {
                    const animation = new GridAnimation(gridAnimationEl);
                    this.gridAnimations.push(animation);
                });
            }
            this.scroll = new GrowthSmoothScroll(this);
        } else {
            this.animationMobile = new AnimationMobile();
        }
        this.videoPlayer = new VideoPlayer()
        this.heroAnimation = new HeroAnimation();
        this.latest = new Latest()
        this.bind();
        this.initEvents();
        this.update();
        this.main.removeAttribute('style');
    }

    initEvents() {
        window.addEventListener('unload', function(e){
            document.body.style.display = 'none';
        });

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        this.sizes.on('resize', this.resize);
    }

    update(time) {
        requestAnimationFrame(this.update);
    }

    bind() {
        this.update = this.update.bind(this);
        this.resize = this.resize.bind(this);
    }

    initCellsLayout() {
        this.sizesCell.cell = parseFloat(getComputedStyle(this.body).getPropertyValue('--grid-cell-size'));
        this.sizesCell.width = this.body.offsetWidth;
        this.sizesCell.cellsHorizontal = Math.floor(this.sizesCell.width / this.sizesCell.cell);

        const totalCellsWidth = this.sizesCell.cellsHorizontal * this.sizesCell.cell;
        const remainingSpace = this.sizesCell.width - totalCellsWidth;
        this.sizesCell.offset = Math.ceil(remainingSpace / 2 + (this.sizesCell.cellsHorizontal % 2 === 0 ? this.sizesCell.cell / 2 : 0));

        let verticalLineOffset = this.sizesCell.offset; // Start with basic offset
        if (this.sizes.width >= 1520) {
            const multiplier = verticalLineOffset > this.sizesCell.cell / 2 ? 1 : 2;
            verticalLineOffset += this.sizesCell.cell * multiplier;
        } else if (this.sizes.width >= 1480 && this.sizes.width < 1520) {
            const multiplier = verticalLineOffset > this.sizesCell.cell / 1.3 ? 0 : 1;
            verticalLineOffset += this.sizesCell.cell * multiplier;
        } else if (this.sizes.width >= 1300 && this.sizes.width < 1480) {
            const multiplier = verticalLineOffset > this.sizesCell.cell / 2 ? 0 : 1;
            verticalLineOffset += this.sizesCell.cell * multiplier;
        } else if (this.sizes.width < 768) {
            const multiplier = verticalLineOffset > this.sizesCell.cell / 2 ? 0 : 1;
            verticalLineOffset += this.sizesCell.cell * multiplier;
        }

        const cardsRow = document.querySelector('.cards-row');
        const gridContainer = document.querySelector('#main .gw-grid');

        if (cardsRow && gridContainer) {
            const negativeMargin = parseFloat(getComputedStyle(cardsRow.querySelector('.card-item')).getPropertyValue('padding') || '0');
            const cardsRowOffset = (
                cardsRow.getBoundingClientRect().top -
                gridContainer.getBoundingClientRect().top -
                negativeMargin
            );

            const cellsBeforeRow = Math.floor(cardsRowOffset / this.sizesCell.cell);

            this.sizesCell.verticalOffset = Math.ceil(cardsRowOffset - (cellsBeforeRow * this.sizesCell.cell));

            this.body.style.setProperty('--grid-cell-offset', `${this.sizesCell.offset}px`);
            // this.body.style.setProperty('--grid-cell-vertical-offset', `${this.sizesCell.verticalOffset}px`);
            this.body.style.setProperty('--grid-vertical-line-offset', `${verticalLineOffset}px`);
        }
    }

    resize() {
        this.initCellsLayout();
        this.heroAnimation?.resize();
        this.gridAnimations?.forEach(animation => animation.resize());
    }
}
